<template>
    <div class="page">
        <div class="title">{{ title }} {{ specName }}会员兑换码</div>
        <div class="list-title">
            <span>兑换码</span>
            <span>有效期至</span>
            <span>状态</span>
            <span v-if="isCopy">操作</span>
        </div>
        <div class="list">
            <div class="item" v-for="item in codeList" :key="item.code">
                <span>{{ item.code }}</span>
                <span>{{ item.expireTime }}</span>
                <span
                    class="status"
                    :class="[item.used ? 'used' : item.expire ? 'expire' : '']"
                    >{{
                        item.used ? "已使用" : item.expire ? "已过期" : "未使用"
                    }}</span
                >
                <span v-if="isCopy" class="copy" @click="copy(item.code)">
                    复制
                </span>
            </div>
        </div>
        <input type="text" class="hide" readonly />
    </div>
</template>

<script>
import { Toast } from "vant";
import bulkBuyService from "../../service/bulk-buy.service";
export default {
    name: "bulk-buy-code",
    data() {
        return {
            isCopy: false,
            id: "",
            specId: "",
            codeList: "",
            title: "",
            specName: "",
        };
    },
    created() {
        this.id = this.$route.params.id;
        this.specId = this.$route.params.specId;
        console.log(this.id, this.specId);
        if (document.execCommand) {
            this.isCopy = true;
        }
        if (this.id && this.specId) {
            this.getPiliangCode();
        }
    },
    methods: {
        getPiliangCode() {
            bulkBuyService
                .getPiliangCode({ id: this.id, specId: this.specId })
                .then((res) => {
                    this.title = res.data.title;
                    this.specName = res.data.specName;
                    this.codeList = res.data.list;
                });
        },
        copy(code) {
            let inputEl = document.querySelector("input.hide");
            inputEl.value = code;
            inputEl.select();
            document.execCommand("copy");
            Toast("复制成功");
        },
    },
};
</script>

<style lang="scss" scoped src="./bulk-buy-code.scss">
</style>